import React from 'react';
import { string } from 'prop-types';
import isNil from 'lodash/isNil';
import classNames from 'classnames';
import Alert from '@active/react-ui/Alert';
import {
  cleanHtml as cleanHtmlFun,
} from '../../../../shared/utils/commonUtils';

const PromptMessage = ({
  message, className,
}) => {
  if (isNil(message)) {
    return null;
  }
  const classes = classNames({
    'prompt-message': true,
    'cui-mg-t-20': true,
  }, className);

  const cleanHtml = cleanHtmlFun(message);

  return (
    <Alert theme="inline" className={classes} data-testid="prompt-message-test">
      <div dangerouslySetInnerHTML={{ __html: cleanHtml }} />
    </Alert>);
};

PromptMessage.propTypes = {
  message: string,
  className: string,
};

export default PromptMessage;
